<template>
  <div class="c-idea g-container">
    <Breadcrumb class="m-bread">
      <BreadcrumbItem> <Icon type="ios-home-outline"></Icon> 项目 </BreadcrumbItem>
      <BreadcrumbItem> <Icon type="ios-cafe"></Icon> 广告 </BreadcrumbItem>
    </Breadcrumb>

    <!-- 滚动区域 -->
    <div class="module-content" ref="container">
      <moduler :name="item.href" v-for="item in subModulesArr" :key="item.id" :title="item.name">
        <template v-if="item.href === 'idea_tool'">
          <affix target="c-create-scroll" :offsetTop="65">
            <div class="c-idea-bar">
              <div ref="barContent" class="c-bar-content">
                <template v-for="(creative, i) in creativeData">
                  <div :key="i" @click.stop="setIdea(i)" :class="classes(creative)">
                    <span>广告组{{ i + 1 }}</span>
                    <span class="m-remove" @click.stop="delIdea(i)">x</span>
                  </div>
                </template>
              </div>
              <div class="c-add-btn">
                <Button type="info" :disabled="ideaLen" @click.stop="appendIdea">复制广告</Button>
                <!-- <Button type="info" :disabled="!accountData.length" @click.stop="selectIdea">选择创意组</Button> -->
              </div>
            </div>
          </affix>
        </template>

        <!-- 广告创意素材 -->
        <template v-if="item.href === 'idea_media'">
          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">计划组名称</span>
            </Col>
            <Col span="12">
              <input-len v-model="formItem.campaign_name" placeholder="最大50个字符，1个中文等于2个字符" width="480" :max="20" />
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">创意方式</span>
            </Col>

            <Col span="12">
              <RadioGroup v-model="formItem.creative_mode" type="button">
                <Radio :label="1"> 常规创意 </Radio>
                <Radio :label="2"> 抖音达人视频 </Radio>
              </RadioGroup>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12" v-if="formItem.creative_mode === 2">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">创意素材</span>
            </Col>

            <Col span="12"> <p style="line-height: 32px">【抖音达人视频】到下一步进行设置</p> </Col>
          </Row>

          <template v-if="formItem.creative_mode === 1">
            <Row class="row-item" :gutter="12">
              <Col span="4" class="col-item">
                <span class="item-field row-item-must">创意素材</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="formItem.image_mode" type="button">
                  <Radio label="CREATIVE_IMAGE_MODE_VIDEO">
                    视频 {{ formItem.videoCreative && formItem.videoCreative.length ? `(${formItem.videoCreative.length})` : '' }}
                  </Radio>

                  <!-- 巨量广告稳定创意参数搜索： carousel_material_list -->
                  <Radio label="CREATIVE_IMAGE_MODE_CAROUSEL"> 图文 </Radio>

                  <Radio label="CREATIVE_IMAGE_MODE_SMALL" v-if="!isDouyin">
                    小图 {{ formItem.imageCreative && formItem.imageCreative.length ? `(${formItem.imageCreative.length})` : '' }}
                  </Radio>
                  <Radio label="CREATIVE_IMAGE_MODE_LARGE" v-if="!isDouyin">
                    大图 {{ formItem.largeCreative && formItem.largeCreative.length ? `(${formItem.largeCreative.length})` : '' }}
                  </Radio>
                  <!-- <Radio label="CREATIVE_IMAGE_MODE_GROUP" v-if="plan.union_video_type !== 'REWARDED_VIDEO' && !statiAssemble">组图 {{(formItem.groupCreative && formItem.groupCreative.length) ? `(${formItem.groupCreative.length})` : ''}}</Radio> -->
                </RadioGroup>
              </Col>
            </Row>
            <Row v-if="formItem.image_mode === 'CREATIVE_IMAGE_MODE_VIDEO'" class="row-item" :gutter="12">
              <Col span="4" class="row-item-label m-creat-box">
                <Button type="default" icon="md-add" @click="addCreative('video')"></Button>
              </Col>
              <Col span="18">
                <creative
                  type="video"
                  :data="formItem.videoCreative"
                  :words="wordIds"
                  :title="Boolean(!statiAssemble)"
                  :local="false"
                  @on-trend="appendTrend"
                  @on-clear="deleteTrend"
                  @on-select="selectImage"
                  @on-delete="deleteItem"
                  @on-del-trend="delTrend"
                ></creative>
              </Col>
            </Row>

            <Row v-if="formItem.image_mode === 'CREATIVE_IMAGE_MODE_CAROUSEL'" class="row-item" :gutter="12">
              <Col span="4" class="row-item-label m-creat-box"> </Col>

              <Col span="18">
                <div style="color: red">注意：【图文】为白名单功能</div>
                <div class="empty-block">【图文】到下一步进行设置</div>
              </Col>
            </Row>

            <Row v-if="formItem.image_mode === 'CREATIVE_IMAGE_MODE_SMALL'" class="row-item" :gutter="12">
              <Col span="4" class="row-item-label m-creat-box">
                <Button type="default" icon="md-add" @click="addCreative('image')"></Button>
              </Col>
              <Col span="18">
                <creative
                  type="image"
                  :data="formItem.imageCreative"
                  :words="wordIds"
                  :title="Boolean(!statiAssemble)"
                  :local="false"
                  @on-trend="appendTrend"
                  @on-clear="deleteTrend"
                  @on-select="selectImage"
                  @on-delete="deleteItem"
                  @on-del-trend="delTrend"
                ></creative>
              </Col>
            </Row>
            <Row v-if="formItem.image_mode === 'CREATIVE_IMAGE_MODE_LARGE'" class="row-item" :gutter="12">
              <Col span="4" class="row-item-label m-creat-box">
                <Button type="default" icon="md-add" @click="addCreative('large')"></Button>
              </Col>
              <Col span="18">
                <creative
                  type="large"
                  :data="formItem.largeCreative"
                  :words="wordIds"
                  :title="Boolean(!statiAssemble)"
                  :local="false"
                  @on-trend="appendTrend"
                  @on-clear="deleteTrend"
                  @on-select="selectImage"
                  @on-delete="deleteItem"
                  @on-del-trend="delTrend"
                ></creative>
              </Col>
            </Row>
            <Row v-if="formItem.image_mode === 'CREATIVE_IMAGE_MODE_GROUP'" class="row-item" :gutter="12">
              <Col span="4" class="row-item-label m-creat-box">
                <Button type="default" icon="md-add" @click="addCreative('group')"></Button>
              </Col>
              <Col span="18">
                <creative
                  type="group"
                  :data="formItem.groupCreative"
                  :words="wordIds"
                  :title="Boolean(!statiAssemble)"
                  :local="false"
                  @on-trend="appendTrend"
                  @on-clear="deleteTrend"
                  @on-select="selectImage"
                  @on-delete="deleteItem"
                  @on-del-trend="delTrend"
                ></creative>
              </Col>
            </Row>
          </template>

          <Row v-if="statiAssemble" class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">创意标题</span>
            </Col>
            <Col span="12">
              <div>
                <Button icon="md-add" @click="addTitleList" :disabled="titleLen === 10">创意标题</Button>
                <span style="padding: 0 8px">已选：{{ titleLen }}/10</span>
                <Button type="primary" @click="docModel = true" :disabled="titleLen === 10" style="margin-left: 20px">选择文案</Button>
              </div>
            </Col>
          </Row>
          <Row v-if="statiAssemble" class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field">&nbsp;</span>
            </Col>
            <Col span="12">
              <m-caption
                v-for="(item, idx) in formItem.title_list"
                :key="idx"
                :index="idx"
                :max-len="60"
                v-model="item.title"
                :words="wordIds"
                :del="titleLen > 1"
                @on-trend="appendTrend"
                @on-clear="deleteTrend"
                @on-delete="delTitleList"
                @on-del-trend="delTrend"
              ></m-caption>
              <span style="color: #ff4400; margin-top: 6px; display: none"
                >注意：添加了动态词，再清除动态词，一定要使用【清除动态词】按钮，否则系统会报错</span
              >
            </Col>
          </Row>

          <Row v-if="plan.download_type === 'DOWNLOAD_URL'" class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">应用名</span>
            </Col>
            <Col span="12"><Input v-model="formItem.app_name" placeholder="4-20个字符,中文占两个字符"></Input></Col>
          </Row>

          <Row v-if="plan.landing_type === 'MICRO_GAME'" class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">来源</span>
            </Col>
            <Col span="12"><Input v-model="formItem.source" placeholder="4-20个字符,中文占两个字符"></Input></Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">产品LOGO</span>
            </Col>
            <Col span="12">
              <cardptom-icon v-model="formItem.image_ids" :sources="creatives_detail" @on-select="selectLogo" />
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">产品卖点</span>
            </Col>
            <Col span="12" style="margin-left: -3px">
              <add-tags
                v-model="formItem.selling_points"
                :open-id="opId"
                :is-show-select="false"
                :max-tag-num="10"
                :min-len="12"
                :max-len="18"
                @on-close="closeTag($event, 'selling_points')"
              ></add-tags>
            </Col>
          </Row>

          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">行动号召文案</span>
            </Col>
            <Col span="12" style="margin-left: -3px">
              <add-tags
                v-model="formItem.call_to_action_buttons"
                :open-id="opId"
                :is-show-select="false"
                :max-tag-num="10"
                :min-len="4"
                :max-len="12"
                @on-close="closeTag($event, 'call_to_action_buttons')"
              ></add-tags>
            </Col>
          </Row>
        </template>

        <!-- 广告预算与出价 -->
        <template v-if="item.href === 'idea_budget'">
          <Row class="row-item" :gutter="12" v-if="isOffSwitch">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">预算</span>
            </Col>
            <Col span="12">
              <Input
                v-model="formItem.budget"
                @on-blur="inputTrim('budget', formItem.budget, formItem, true)"
                placeholder="预算不少于300元，不超过9999999.99元"
                style="width: 267px"
              >
                <span slot="append">元</span>
              </Input>
            </Col>
          </Row>
          <!-- 最大转化不显示出价 -->
          <template v-if="bid_type !== 'NO_BID'">
            <Row class="row-item" :gutter="12">
              <Col span="4" class="col-item">
                <span class="item-field row-item-must">出价</span>
              </Col>
              <Col span="12">
                <Input
                  v-model="formItem.cpa_bid"
                  @on-blur="inputTrim('cpa_bid', formItem.cpa_bid, formItem, true)"
                  placeholder="预算不少于0.1元，不超过10000元"
                  style="width: 267px"
                >
                  <span slot="append">元</span>
                </Input>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12" v-if="deep_bid_type === 'DEEP_BID_MIN'">
              <Col span="4" class="col-item">
                <span class="item-field row-item-must">深度目标出价</span>
              </Col>
              <Col span="12">
                <Input
                  v-model="formItem.deep_cpabid"
                  @on-blur="inputTrim('deep_cpabid', formItem.deep_cpabid, formItem, true)"
                  placeholder="请输入0.1~10000的深度优化出价"
                  style="width: 320px"
                >
                </Input>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12" v-if="deep_bid_type === 'ROI_COEFFICIENT'">
              <Col span="4" class="col-item">
                <span class="item-field row-item-must">ROI系数</span>
              </Col>
              <Col span="12">
                <Input
                  v-model="formItem.roi_goal"
                  @on-blur="inputTrimFour('roi_goal', formItem.roi_goal, formItem, true)"
                  placeholder="请输入ROI系数，ROI系数不大于5，保留小数点后四位"
                  style="width: 320px"
                >
                </Input>
              </Col>
            </Row>
          </template>
          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">广告名称</span>
            </Col>
            <Col span="12">
              <div class="col-flex" style="height: 32px">
                <span style="color: #aaa">同项目名称</span>
              </div>
            </Col>
          </Row>
        </template>
      </moduler>
    </div>

    <uploader
      v-model="creativeModel"
      :multiple="creativeMult"
      :media="media"
      :width="creativeWidth"
      :height="creativeHeight"
      :type="creativeType"
      :smart="creativeSmart"
      :default-option="plan.gameId"
      @on-upload="uploadFileHandler"
      @on-cancel="creativeMult = false"
    ></uploader>

    <document v-model="docModel" :open-id="opId" @on-select="appendDocument" @on-cancel="docModel = false"></document>

    <div class="c-idea-submit">
      <Row :gutter="12">
        <Col span="12">
          <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="errRes = []"></error-pop>
        </Col>
        <Col span="12" class="c-btns-submit">
          <Button type="default" @click.stop="back">上一步</Button>
          <Button type="primary" @click.stop="submit">下一步</Button>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import mixin from './mixin'
import { getSession, setLocalforage, getLocalforage, div } from '@/common/js/api'

import { isArray, isEmpty, trim, getByteLen, pullKeys, timeout } from '@/common/js/utils'

import { adAccount } from '@/api/common.model'
import { getCreativeWordIds, getAppNameByMediaId } from '@/api/toutiao.model'

import categroyData from '@/data/toutiao/ad_categroy'
import MCaption from '@/components/caption.vue'
import AddTags from '@/components/add-tags.vue'
import Creative from './components/idea/creative/creative.vue'
import Uploader from './components/idea/uploader.vue'
import Document from './components/idea/document/document.vue'
import CardptomIcon from '@/components/cardptom/icon.vue'

const defaultIdeaParams = {
  campaign_name: '广告组1',
  title_list: [
    {
      title: '',
      creative_word_ids: []
    }
  ],
  image_list: [],

  image_mode: 'CREATIVE_IMAGE_MODE_VIDEO',
  imageCreative: [],
  largeCreative: [],
  groupCreative: [],
  videoCreative: [],

  creative_mode: 1,

  // 产品信息
  selling_points: [], // 产品卖点
  image_ids: '',

  call_to_action_buttons: [], // 行动号召文案

  // 广告预算与出价
  budget: '', // 预算
  cpa_bid: '', // 出价
  deep_cpabid: '', // 深度目标出价
  roi_goal: '', // ROI系数

  app_name: '',
  creative_display_mode: 'CREATIVE_DISPLAY_MODE_CTR', // 创意展现方式
  creative_material_mode: 'STATIC_ASSEMBLE' // 创意类型
}

export default {
  name: 'idea',
  mixins: [mixin],
  components: { AddTags, Creative, Uploader, MCaption, Document, CardptomIcon },
  computed: {
    editState() {
      return this.$route.query.t === 'edit'
    },
    classes() {
      return (item) => {
        return ['m-creative-btn', { 'm-current': item.check }]
      }
    },
    formItem() {
      const items = this.creativeData.filter((ret) => ret.check)
      return items.pop() || { campaign_name: '' }
    },
    ideaLen() {
      return this.creativeData.length >= 100
    },
    titleLen() {
      if (this.formItem && this.formItem.title_list) {
        return this.formItem.title_list.length
      } else {
        return 0
      }
    },
    statiAssemble() {
      return this.formItem.creative_material_mode === 'STATIC_ASSEMBLE'
    },
    creativeMax() {
      return 30 - this.creativeData.length
    },
    creativeImageMode() {
      return this.formItem.image_mode
    },
    accountId() {
      return getSession('ad_account_ids')[0].id || 3232
    },
    subModulesArr() {
      // 自动投放不显示广告预算与出价
      if (this.projectDeliveryMode === 'PROCEDURAL') {
        return this.subModules.filter((s) => s.href !== 'idea_budget')
      }
      return this.subModules
    }
  },
  data() {
    return {
      projectDeliveryMode: '', // 项目投放模式
      deep_bid_type: '', // 上一步深度优化方式
      bid_type: '', // 上一步优化方式
      isOffSwitch: null, // 上一步是否开启择优分配
      isDouyin: null, // 版位是否全是仅抖音
      wordIds: [], // 创意词标题
      categroyData: categroyData,
      // 上传组件
      creativeWidth: '',
      creativeHeight: '',
      creativeMult: false, // 是否多选
      creativeModel: null, // 弹框是否显示
      creativeType: 'video', // 上传类型
      creativeSmart: '', // 智能封面
      campaignModal: false, // 导入创意弹窗
      asynloading: null, // 复制导入创意状态

      creatives_detail: [], // logo 数据源返显

      // 选择文案
      docModel: null,
      // 多个创意
      creativeData: [],
      accountData: [], // 选择创意的账号
      plan: {}
    }
  },
  watch: {},
  methods: {
    // 获取原来的草稿
    async getData(formItem) {
      // const creativeData = getSession('creative_params') || []
      let creativeData = []
      try {
        creativeData = await getLocalforage('creative_params')
      } catch (e) {
        console.log(e)
      }

      // 有草稿创意
      if (isArray(creativeData) && creativeData.length) {
        this.creativeData = creativeData.map((ret) => {
          if (this.isDouyin) ret.image_mode = 'CREATIVE_IMAGE_MODE_VIDEO'
          isArray(ret.creatives_detail) && this.creatives_detail.push(...ret.creatives_detail)
          return ret
        })
      } else this.appendIdea() // 增加一个创意
      this.setIdea(0)
    },
    // 添加素材
    addCreative(type) {
      this.creativeSmart = ''
      this.creativeWidth = ''
      this.creativeHeight = ''
      this.creativeMult = true
      this.creativeType = type
      this.creativeModel = true
    },
    createMultipleCreative(list) {
      if (!isArray(list)) return
      const some = list.some(
        (ret) => !isArray(ret.items) || ret.items.some((t) => t.type === 'video' && (!isArray(t.video) || !isArray(t.cover)))
      )
      if (some) {
        this.$Message.error('上传的视频或封面错误')
        return
      }
      const multCreative = list.map((m) => {
        // 判断服务端错误
        if (isArray(m.items)) {
          if (this.creativeType === 'image' || this.creativeType === 'large') {
            const pop = m.items.pop()
            Object.assign(pop, { title: '', creative_word_ids: [] })
            return pop
          } else if (this.creativeType === 'group') {
            return { title: '', creative_word_ids: [], children: m.items }
          } else if (this.creativeType === 'video') {
            const pop = m.items.pop()
            const { video, cover } = pop
            return { title: '', creative_word_ids: [], children: [video.pop(), cover.pop()] }
          }
        }
      })
      this.formItem[`${this.creativeType}Creative`].push(...multCreative)
      this.creativeModel = false // 关闭对话框
    },
    // 选择素材上传入口
    selectImage({ type, index }) {
      if (type === 'group' && isArray(index)) type = 'image'
      if (type === 'video' && isArray(index)) {
        const idx = index[0]
        // 智能封面依赖视频ID
        const videoItem = this.formItem[`${type}Creative`][idx].children[0]
        if (videoItem.id || videoItem.video_id) this.creativeSmart = videoItem.id || videoItem.video_id
        type = 'large'
      } else this.creativeSmart = ''
      this.creativeWidth = ''
      this.creativeHeight = ''
      this.creativeMult = false
      this.creativeModel = true
      this.creativeType = type
      // 保存更新位置
      if (type === 'group' || type === 'video') {
        if (typeof index.index !== 'undefined') this.creativeIndex = index.index
      } else this.creativeIndex = index
    },
    // 删除选择框
    deleteItem({ type, index }) {
      this.formItem[`${type}Creative`].splice(index, 1)
    },
    // 选完素材回调
    uploadFileHandler(list) {
      if (this.creativeMult) this.createMultipleCreative(list)
      else {
        let item
        // 判断服务端错误
        if (isArray(list)) {
          if (this.creativeType === 'image' || this.creativeType === 'large') {
            const pop = list.pop()
            if (isArray(this.creativeIndex)) {
              const [index, idx] = this.creativeIndex
              if (typeof idx === 'number') this.formItem.groupCreative[index].children.splice(idx, 1, pop)
              else if (typeof idx === 'string') this.formItem.videoCreative[index].children.splice(1, 1, pop)
            } else {
              item = Object.assign(this.formItem[`${this.creativeType}Creative`][this.creativeIndex], pop)
              this.formItem[`${this.creativeType}Creative`].splice(this.creativeIndex, 1, item)
            }
          } else if (this.creativeType === 'group') {
            item = Object.assign(this.formItem[`${this.creativeType}Creative`][this.creativeIndex], { children: list })
            this.formItem[`${this.creativeType}Creative`].splice(this.creativeIndex, 1, item)
          } else if (this.creativeType === 'video') {
            // 更新视频
            const pop = list.pop()
            this.formItem.videoCreative[this.creativeIndex].children.splice(0, 1, pop)
          } else if (this.creativeType === 'logo') {
            // 卡片LOGO
            const pop = list.pop()
            if (pop) {
              if (!['jpg', 'png'].includes(pop.source_file_type)) {
                return this.$Message.warning('请选择jpg/png格式的图片')
              }

              pop.id = String(pop.id)
              const idx = list.findIndex((ret) => ret.id === pop.id)
              this.$set(this.formItem, 'image_ids', pop.id)
              if (idx < 0) this.creatives_detail.push(pop)
            }
          }
        } else if (list && list.type === 'video') {
          // 视频组
          const { video, cover } = list
          if (!isArray(video)) {
            this.$Message.error('上传视频时失败')
            this.creativeModel = false
            return
          } else if (!isArray(cover)) {
            this.$Message.error('上传封面时失败')
            this.creativeModel = false
            return
          }
          this.formItem.videoCreative[this.creativeIndex].children = [video.pop(), cover.pop()]
        } else console.log('上传素材返回错误')

        // 关闭对话框
        this.creativeModel = false
      }
    },
    // 删除标签
    closeTag(name, data) {
      const index = this.formItem[data].findIndex((ret) => ret === name)
      if (index > -1) this.formItem[data].splice(index, 1)
    },
    // 增加标题
    addTitleList(ret) {
      let words = []
      const title = ret.docContent
      const creative_word_ids = ret.creativeWordIdsJson
      const val = typeof title === 'string' ? title : ''
      if (isArray(creative_word_ids)) words = this.pushWordIds(this.wordIds, creative_word_ids, title)
      this.formItem.title_list.push({
        title: val,
        creative_word_ids: words
      })
    },
    // 删除标题
    delTitleList(index) {
      this.formItem.title_list.splice(index, 1)
    },
    // 添加动态词
    appendTrend(params) {
      const { type, index, trend, direction } = params
      const meta = type === 'smart' ? this.formItem.title_list : this.formItem[`${type}Creative`]
      const len = meta[index].creative_word_ids.length
      const { title } = meta[index]
      if (len >= 2) {
        if (direction === 'left') {
          meta[index].creative_word_ids.shift()
          meta[index].creative_word_ids.unshift(trend)
        } else if (direction === 'right' || direction === 'plus-right') {
          if (direction === 'plus-right') trend.cut -= 4
          meta[index].creative_word_ids.pop()
          meta[index].creative_word_ids.push(trend)
        }
      } else if (len && direction === 'left') {
        meta[index].creative_word_ids.unshift(trend)
      } else {
        meta[index].creative_word_ids.push(trend)
      }
      meta[index].title = this.reflashTitle(title, meta[index].creative_word_ids, direction)
    },
    // 清除动态词
    deleteTrend(params) {
      const { type, index } = params
      const meta = type === 'smart' ? this.formItem.title_list : this.formItem[`${type}Creative`]
      meta[index].creative_word_ids = []
      meta[index].title = meta[index].title.replace(/{[\u4e00-\u9fa5]{2,}}/g, '')
    },
    pushWordIds(list, ids, title) {
      const arr = []
      let pos = -1
      if (isArray(ids)) {
        ids.forEach((ret, idx) => {
          const word = list.filter((meta) => meta.creative_word_id === ret)
          if (word.length) {
            pos = title.indexOf('{', pos)
            arr.push(...word)
            if (pos > -1) arr[idx].cut = pos
          }
        })
      }
      return arr
    },
    // 退格删除动态词
    delTrend(params) {
      const { type, index, order } = params
      const meta = type === 'smart' ? this.formItem.title_list : this.formItem[`${type}Creative`]
      // 2动态词 变1时，且是删除了左边动态词
      if (isArray(meta[index].creative_word_ids) && meta[index].creative_word_ids.length > 1 && order === 0) {
        const title = JSON.parse(JSON.stringify(meta[index].title))
        if (meta[index].creative_word_ids.length) {
          meta[index].creative_word_ids[1].cut = title.indexOf(`{${meta[index].creative_word_ids[1].name}}`)
        }
      }
      meta[index].creative_word_ids.splice(order, 1)
      meta[index].title = this.reflashTitle(meta[index].title, meta[index].creative_word_ids)
    },
    // 刷新标题
    reflashTitle(title, words, direction = 'left') {
      let newTitle
      if (words.length >= 2) {
        title = title.replace(/{[\u4e00-\u9fa5]{2,}}/g, '')
        const prefix = title.substring(0, words[0].cut)
        const midfix = direction === 'left' ? title.substring(words[0].cut, words[1].cut) : title.substring(words[0].cut, words[1].cut - 4)
        const suffix = direction === 'left' ? title.substring(words[1].cut) : title.substring(words[1].cut - 4)
        newTitle = `${prefix}{${words[0].name}}${midfix}{${words[1].name}}${suffix}`
      } else if (words.length) {
        title = title.replace(/{[\u4e00-\u9fa5]{2,}}/g, '')
        const prefix = title.substring(0, words[0].cut)
        const suffix = title.substring(words[0].cut)
        newTitle = `${prefix}{${words[0].name}}${suffix}`
      } else {
        newTitle = title.replace(/{[\u4e00-\u9fa5]{2,}}/g, '')
      }
      return newTitle
    },
    // 选择文案回调
    appendDocument(docs) {
      const len = this.formItem.title_list.length
      if (docs.length > 10 - len) {
        const idx = docs.length - (10 - len)
        docs.splice(-idx, idx)
      }
      docs.forEach((ret) => {
        this.addTitleList(ret)
      })
      this.docModel = false
    },
    mergeCreative(ret) {
      const imageCreative = this.build('image', ret)
      const largeCreative = this.build('large', ret)
      const groupCreative = this.build('group', ret)
      const videoCreative = this.build('video', ret)
      return [...imageCreative, ...largeCreative, ...groupCreative, ...videoCreative]
    },
    build(type, ret) {
      const arr = []
      if (['image', 'large'].includes(type)) {
        ret[`${type}Creative`].forEach((ret) => {
          arr.push({
            image_mode: ret.image_mode,
            title: ret.title,
            creative_word_ids: ret.creative_word_ids.map((meta) => meta.creative_word_id || meta),
            image_ids: [ret.id]
          })
        })
        return arr
      } else if (type === 'group') {
        ret[`${type}Creative`].forEach((ret) => {
          arr.push({
            image_mode: 'CREATIVE_IMAGE_MODE_GROUP',
            title: ret.title,
            creative_word_ids: ret.creative_word_ids.map((meta) => meta.creative_word_id || meta),
            image_ids: ret.children.map((child) => child.id)
          })
        })
        return arr
      } else if (type === 'video') {
        ret[`${type}Creative`].forEach((ret) => {
          arr.push({
            image_mode: ret.children[0].image_mode,
            title: ret.title,
            creative_word_ids: ret.creative_word_ids.map((meta) => meta.creative_word_id || meta),
            image_id: ret.children[1].id,
            video_id: ret.children[0].id,
            cover: ret.children[1].imageDetailId ? 1 : 0
          })
        })
        return arr
      }
    },
    getVideoCount(list) {
      if (!isArray(list)) return 0
      const count = list.filter(
        (ret) => ret.image_mode === 'CREATIVE_IMAGE_MODE_VIDEO' || ret.image_mode === 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL'
      ).length
      return count
    },
    getImageCount(list) {
      let imgCount = 0
      if (!isArray(list)) return 0
      const count = list.filter(
        (ret) => ret.image_mode === 'CREATIVE_IMAGE_MODE_VIDEO' || ret.image_mode === 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL'
      ).length
      const imageList = list.filter((ret) =>
        [
          'CREATIVE_IMAGE_MODE_SMALL',
          'CREATIVE_IMAGE_MODE_LARGE',
          'CREATIVE_IMAGE_MODE_LARGE_VERTICAL',
          'CREATIVE_IMAGE_MODE_GROUP'
        ].includes(ret.image_mode)
      )
      imageList.forEach((ret) => {
        imgCount += ret.image_ids.length
      })
      return imgCount + count
    },
    appendIdea() {
      let ideaParam
      const len = this.creativeData.length
      const fmt_formItem = JSON.parse(JSON.stringify(this.formItem))
      if (this.formItem.image_mode) ideaParam = this.formItem // 复制已有创意
      else ideaParam = Object.assign(defaultIdeaParams, fmt_formItem)
      ideaParam = Object.assign({}, ideaParam, { campaign_name: `广告组${len + 1}` }) // 增加标题
      this.creativeData.push(JSON.parse(JSON.stringify(ideaParam)))
      this.setIdea(this.creativeData.length - 1)
      this.$nextTick(() => {
        this.$refs.barContent[0] && (this.$refs.barContent[0].scrollLeft = 1500)
      })
    },
    setIdea(index) {
      const item = this.creativeData[index]
      this.creativeData.forEach((ret) => {
        this.$set(ret, 'check', false)
      })
      this.$set(item, 'check', true)
    },
    delIdea(index) {
      const idx = this.creativeData.findIndex((ret) => ret.check)
      const len = this.creativeData.length
      if (len < 2) {
        this.$Message.error({
          closable: true,
          duration: 5,
          content: '不能删除最后一个广告组'
        })
        return
      }
      // 删除自己
      if (index === idx) {
        if (index > 0) this.setIdea(index - 1)
        else this.setIdea(1)
      }
      this.creativeData.splice(index, 1)
    },
    preloadData() {
      const myWordIds = [1736, 1727, 4, 1737, 5128, 5127] // 获取创意词包
      const out_plan_info = getSession('outer_plan_params') || {}
      const plan_info = getSession('inner_plan_params') || {}
      const targetings = getSession('targetings') || {}
      this.isDouyin = targetings.every(
        (ret) => ret.targetingParam.inventory_type.length === 1 && ret.targetingParam.inventory_type.includes('INVENTORY_AWEME_FEED')
      )
      // 上一步优化方式
      this.bid_type = out_plan_info.delivery_setting.bid_type
      this.deep_bid_type = out_plan_info.delivery_setting.deep_bid_type

      this.projectDeliveryMode = out_plan_info.delivery_mode

      // 上一步是否开启预算择优分配，开启了就不能填预算
      this.isOffSwitch = out_plan_info.delivery_setting.budget_optimize_switch === 'OFF'
      // 查询计划是否是穿山甲
      this.plan.union_video_type = out_plan_info.union_video_type // 原生 激励视频
      this.plan.app_type = out_plan_info.app_type
      this.plan.download_type = out_plan_info.download_type || (plan_info.landing_type === 'LINK' ? 'EXTERNAL_URL' : 'DOWNLOAD_URL')
      this.plan.gameId = parseInt(plan_info.game_id)
      this.plan.landing_type = plan_info.landing_type

      this.$Spin.show()
      Promise.all([
        getCreativeWordIds({ account: this.accountId }),
        adAccount({ mediaId: this.media, authFlag: 1 }),
        getAppNameByMediaId({ mediaId: this.media, gameId: this.plan.gameId })
      ]).then((data) => {
        this.$Spin.hide()
        const [creativeWordIds, accounts, appName] = data
        if (appName) this.formItem.app_name = appName
        if (isArray(accounts)) {
          this.accountData = accounts.map((ret) => {
            return { id: ret.id, name: ret.name, children: [], xhr: false, disabled: false }
          })
        }
        if (creativeWordIds && creativeWordIds.creative_word) {
          this.wordIds = creativeWordIds.creative_word.filter((ret) => myWordIds.includes(ret.creative_word_id))
          if (this.editState) this.getData(this.formItem)
          else {
            // 增加一个创意
            this.appendIdea()
            this.setIdea(0)
          }
        }
      })
    },
    valid(ret) {
      const rules = [
        {
          name: 'campaign_name',
          require: true,
          min: 1,
          max: 50,
          desc: '计划组名称'
        },
        {
          name: 'app_name',
          require: true,
          min: 4,
          max: 20,
          desc: '应用名'
        },
        {
          name: 'selling_points',
          require: true,
          min: 1,
          max: 10,
          desc: '产品卖点'
        },
        {
          name: 'call_to_action_buttons',
          require: true,
          min: 1,
          max: 10,
          desc: '行动号召文案'
        },
        {
          name: 'image_ids',
          require: true,
          desc: '产品LOGO'
        }
      ]
      return this.invalidPlus(ret, rules)
    },
    invalidPlus(ret, rules) {
      const arr = []
      if (!isArray(rules)) throw new Error('rule must be array')
      for (let i = 0; i < rules.length; i++) {
        let param
        let length
        const rule = rules[i]
        const ruleName = rule.name.indexOf('/') > -1 ? ret[rule.name.split('/')[0]][rule.name.split('/')[1]] : ret[rule.name]
        if (typeof ruleName === 'undefined') continue
        if (typeof ruleName === 'string') {
          param = trim(ruleName)
          length = getByteLen(param)
        } else if (isArray(ruleName)) {
          param = ruleName
          length = param.length
        } else {
          param = ruleName
          length = String(param).length
        }

        // 依赖
        if (rule.relyon) {
          const rely = rule.relyon.indexOf('/') > -1 ? ret[rule.relyon.split('/')[0]][rule.relyon.split('/')[1]] : this.plan[rule.relyon]
          if (rely !== rule.relyvalue) continue
        }

        // 必填
        if ((rule.require && !param) || (rule.require && isEmpty(param))) {
          const msg = `${rule.desc}不能为空`
          arr.push({ feild: rule.desc, msg })
          continue
        }

        // 长度判断
        if (param && rule.max < length) {
          const msg = `${rule.desc}不能多于${rule.max}个字符`
          arr.push({ feild: rule.desc, msg })
          continue
        }
        if (param && rule.min > length) {
          const msg = `${rule.desc}不能少于${rule.min}个字符`
          arr.push({ feild: rule.desc, msg: rule.msg || msg })
          continue
        }

        // 正则
        if (rule.pattern) {
          const reg = new RegExp(rule.pattern, 'g')
          if (!reg.test(param)) {
            const msg = `${rule.desc}不是有效的值`
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
        }
      }
      return arr
    },
    invalidExtand(ret) {
      const err = []
      const lenTitle = (val) => {
        let len = 0
        const regexp = /({[\u4e00-\u9fa5]{2,}})/g
        if (!isEmpty(val)) {
          const values = val.match(regexp)
          len += getByteLen(val)
          if (isArray(values)) {
            values.forEach((ret) => {
              ret.includes('{') && (len -= 2)
            })
          }
        }
        return len
      }
      if (this.isDouyin) {
        ret.imageCreative = []
        ret.largeCreative = []
        ret.image_list = ret.image_list.filter(
          (im) => !['CREATIVE_IMAGE_MODE_LARGE', 'CREATIVE_IMAGE_MODE_SMALL', 'CREATIVE_IMAGE_MODE_LARGE_VERTICAL'].includes(im.image_mode)
        )
      }

      const smallCreatives = ret.imageCreative // 小图
      const largeCreatives = ret.largeCreative
      const groupCreatives = ret.groupCreative
      const videoCreatives = ret.videoCreative

      // 图片未上传
      const smallImage = smallCreatives.some((met) => !met.id)
      const smallMsg = smallCreatives.some((met) => met.msg)
      if (smallImage) err.push({ feild: '小图素材', msg: '没有上传素材，不能提交' })
      if (smallMsg) err.push({ feild: '小图素材', msg: '上传的素材不符合规格，不能提交' })
      const largeImage = largeCreatives.some((met) => !met.id)
      const largeMsg = largeCreatives.some((met) => met.msg)
      if (largeImage) err.push({ feild: '大图素材', msg: '没有上传素材，不能提交' })
      if (largeMsg) err.push({ feild: '大图素材', msg: '上传的素材不符合规格，不能提交' })
      const groupImage = groupCreatives.some((met) => met.children.some((t) => !t.id))
      const groupMsg = groupCreatives.some((met) => met.children.some((t) => t.msg))
      if (groupImage) err.push({ feild: '组图素材', msg: '有一个或多个没有上传素材，不能提交' })
      if (groupMsg) err.push({ feild: '组图素材', msg: '上传的素材不符合规格，不能提交' })
      const videoImage = videoCreatives.some((met) => met.children.some((t) => !t.id || !t.url))
      const videoMsg = videoCreatives.some((met) => met.children.some((t) => t.msg))
      if (videoImage) err.push({ feild: '视频素材', msg: '封面或者视频不能为空' })
      if (videoMsg) err.push({ feild: '视频素材', msg: '上传的封面或者视频不符合规格，不能提交' })
      const vertalImage = videoCreatives.some(
        (met) =>
          isArray(met.children[0].image_mode) &&
          met.children[0].image_mode.includes('VERTICAL') !== met.children[1].image_mode.includes('VERTICAL')
      )
      if (vertalImage) err.push({ feild: '视频素材', msg: '视频与封面必须同是横版或竖版' })
      // 合并创意
      ret.creatives = this.mergeCreative(ret)
      // 抖音只支持视频
      // if (ret.smart_inventory !== 1 && ret.inventory_type.includes('INVENTORY_AWEME_FEED')) {
      //   const only = ret.creatives.every(met => met.image_mode === 'CREATIVE_IMAGE_MODE_VIDEO' || met.image_mode === 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL')
      //   if (!only) {
      //     err.push({feild: '创意素材', msg: '抖音仅支持视频创意, 请上传其他创意或修改投放位置'})
      //   }
      // }
      // 判断媒体个数合法
      const videoCount = this.getVideoCount(ret.creatives)
      const imageCount = this.getImageCount(ret.creatives)
      if (videoCount > 10 || imageCount > 10) {
        err.push({ feild: '创意素材', msg: `提交的视频数：${videoCount}，图片数：${imageCount}，最多包含10张图和10个视频` })
      } else if (imageCount === 0 && videoCount === 0) {
        // err.push({ feild: '创意素材', msg: '提交的创意素材不能为空' })
      }
      // 程序化标题长度
      if (ret.creative_material_mode === 'STATIC_ASSEMBLE') {
        const titleVaild = ret.title_list.some((met) => lenTitle(met.title) < 12 || lenTitle(met.title) > 60)
        const titleId = ret.title_list.some((met) => met.creative_word_ids && met.creative_word_ids.some((r) => !r))
        if (titleVaild) {
          err.push({ feild: '创意标题', msg: '标题不能少于12或超过60个字符' })
        }
        if (titleId) {
          err.push({ feild: '创意标题', msg: '标题中含有动态词，动态词ID错误' })
        }
      }

      // 小程序来源不能为空
      if (this.plan.landing_type === 'MICRO_GAME') {
        if (!ret.source) {
          err.push({ feild: '来源', msg: '来源不能为空' })
        }
      }

      // 预算与出价
      if (this.projectDeliveryMode === 'MANUAL') {
        if ((isEmpty(ret.budget) || ret.budget < 300 || ret.budget > 10000000) && this.isOffSwitch) {
          err.push({ feild: '预算', msg: '预算不能为空，且出价范围需在300-9999999.99元之间' })
        }
        if (this.bid_type === 'CUSTOM') {
          if (isEmpty(ret.cpa_bid) || ret.cpa_bid < 0.1 || ret.cpa_bid > 10000) {
            err.push({ feild: '出价', msg: '出价不能为空，且出价范围需在0.1-10000元之间' })
          }

          if (this.deep_bid_type === 'DEEP_BID_MIN' && (isEmpty(ret.deep_cpabid) || ret.deep_cpabid < 0.1 || ret.deep_cpabid > 10000)) {
            err.push({ feild: '深度目标出价', msg: '深度优化出价不能为空，且出价范围需在0.1-10000元之间' })
          }

          if (this.deep_bid_type === 'ROI_COEFFICIENT' && (isEmpty(ret.roi_goal) || ret.roi_goal > 5 || ret.roi_goal <= 0)) {
            err.push({ feild: 'ROI系数', msg: 'ROI系数不能为空，且出价范围需在0~5之间' })
          }
          if (ret.cpa_bid > ret.budget) err.push({ feild: '出价', msg: '出价不能大于预算值' })
        }
      }

      return err
    },
    customValid(creativeData) {
      return creativeData.map((ret) => {
        let err = []
        err = [...this.valid(ret), ...this.invalidExtand(ret)]
        return { err }
      })
    },
    submit() {
      const out_plan_info = getSession('outer_plan_params') || {}
      const plan_info = getSession('inner_plan_params') || {}
      const targetings = getSession('targetings') || []
      const batch_type = getSession('batch_task_type') || 1
      const convert_params = getSession('convert_params') || {}

      const params = {
        outer_plan_params: out_plan_info,
        inner_plan_params: plan_info,
        targetings: targetings.map((ret) => {
          const param = [
            'audiences',
            'gender',
            'age',
            'city',
            'district',
            'interest_action_mode',
            'action_tags',
            'action_scene',
            'action_days',
            'action_categories',
            'action_words',
            'word_tags',
            'interest_categories',
            'interest_words',
            'location_type',
            'activate_type',
            'platform',
            'android_osv',
            'ios_osv',
            'carrier',
            'ac',
            'ad_tag',
            'tags',
            'device_brand',
            'device_type',
            'launch_price',
            'auto_extend_enabled',
            'auto_extend_targets',
            'article_category',
            'app_behavior_target',
            'app_category',
            'superior_popularity_type',
            'flow_package',
            'exclude_flow_package'
          ]
          out_plan_info.pricing === 'PRICING_OCPM' && param.push('hide_if_converted')
          ret.targetingParam = pullKeys(param, ret.targetingParam)
          return ret
        }),
        batch_task_type: parseInt(batch_type),
        convert_params: convert_params
      }

      // params.inner_plan_params.media_targeting_id = targetings.filter(m => m.targetingId).map(ret => ret.targetingId).join(',')

      // 多创意验证
      this.formErr = false
      this.errRes = []
      const customValids = this.customValid(this.creativeData)

      customValids.some((met, idx) => {
        if (met.err && met.err.length) {
          this.errRes = met.err
          this.index = idx
          return true
        }
      })
      if (this.errRes.length) {
        this.setIdea(this.index)
        this.formErr = true
        return // 如果错误中断
      }

      params.creative_params = this.creativeData.map((ret) => {
        ret.creatives = this.mergeCreative(ret)

        // 程序化创意
        if (ret.creative_material_mode === 'STATIC_ASSEMBLE') {
          ret = Object.assign(ret, {
            creative_material_mode: ret.creative_material_mode,
            image_list: ret.creatives,
            title_list: ret.title_list.map((ret) => {
              return {
                title: ret.title,
                creative_word_ids: ret.creative_word_ids.map((meta) => meta.creative_word_id || meta)
              }
            }),
            creatives: []
          })
        }

        ret.creatives_detail = this.creatives_detail
        return pullKeys(
          [
            'campaign_name',
            'creative_display_mode',
            'image_mode',
            'image_list',
            'title_list',
            'app_name',
            'creative_material_mode',
            'creatives',
            'creatives_detail'
          ],
          ret
        )
      })

      // setSession('creative_params', this.creativeData)
      // 使用indexedDB存储
      setLocalforage('creative_params', this.creativeData).then(() => {
        this.$router.push({ name: 'localnewbatch' })
      })
    },
    back() {
      const out_plan_info = getSession('outer_plan_params') || {}
      const plan_info = getSession('inner_plan_params') || {}
      const targetings = getSession('targetings') || []
      const batch_type = getSession('batch_task_type') || 1
      const convert_params = getSession('convert_params') || {}
      const params = {
        outer_plan_params: out_plan_info,
        inner_plan_params: plan_info,
        targetings: targetings.map((ret) => {
          const param = [
            'audiences',
            'gender',
            'age',
            'city',
            'district',
            'interest_action_mode',
            'action_tags',
            'action_scene',
            'action_days',
            'action_categories',
            'action_words',
            'word_tags',
            'interest_categories',
            'interest_words',
            'location_type',
            'activate_type',
            'platform',
            'android_osv',
            'ios_osv',
            'carrier',
            'ac',
            'ad_tag',
            'tags',
            'device_brand',
            'device_type',
            'launch_price',
            'auto_extend_enabled',
            'auto_extend_targets',
            'article_category',
            'app_behavior_target',
            'app_category',
            'superior_popularity_type',
            'flow_package',
            'exclude_flow_package'
          ]
          out_plan_info.pricing === 'PRICING_OCPM' && param.push('hide_if_converted')
          ret.targetingParam = pullKeys(param, ret.targetingParam)
          return ret
        }),
        batch_task_type: parseInt(batch_type),
        convert_params: convert_params
      }
      params.creative_params = this.creativeData.map((ret) => {
        ret.creatives = this.mergeCreative(ret)
        // 程序化创意
        if (ret.creative_material_mode === 'STATIC_ASSEMBLE') {
          ret = Object.assign(ret, {
            creative_material_mode: ret.creative_material_mode,
            image_list: ret.creatives,
            title_list: ret.title_list.map((ret) => {
              return {
                title: ret.title,
                creative_word_ids: ret.creative_word_ids.map((meta) => meta.creative_word_id || meta)
              }
            }),
            creatives: []
          })
        }

        ret.creatives_detail = this.creatives_detail
        return pullKeys(
          [
            'campaign_name',
            'creative_display_mode',
            'image_mode',
            'image_list',
            'title_list',
            'app_name',
            'creative_material_mode',
            'creatives',
            'creatives_detail'
          ],
          ret
        )
      })
      this.$Modal.confirm({
        title: '提示',
        content: '<p>当前编辑数据未保存，返回将丢失编辑数据。</p><p>是否保存当前数据</p>',
        loading: true,
        okText: '是',
        cancelText: '否',
        onOk: () => {
          // setSession('creative_params', this.creativeData)
          // 使用indexedDB存储
          setLocalforage('creative_params', this.creativeData)
          timeout(800).then(() => {
            this.$Modal.remove()
            this.$router.push({
              name: 'localproject',
              query: { t: 'edit' }
            })
          })
        },
        onCancel: () => {
          this.$router.push({
            name: 'localproject',
            query: { t: 'edit' }
          })
        }
      })
    },
    changePlayable() {
      this.formItem.playable_url = ''
    },
    selectLogo() {
      this.creativeWidth = 108
      this.creativeHeight = 108
      this.creativeMult = false
      this.creativeModel = true
      this.creativeType = 'logo'
      this.creativeSmart = ''
    },
    preview(url) {
      window.open(url)
    }
  },
  created() {
    this.$store.commit('Toutiaonewlocal/clearModulerLinks')
    this.preloadData()
  }
}
</script>
<style lang="scss" scoped>
.row-item {
  align-items: flex-start;

  span.item-field {
    height: 32px;
    line-height: 32px;
  }
}

.item-field {
  height: 32px;
  line-height: 32px;
}

.row-item-control {
  margin-top: 12px;
}

.row-item-label {
  text-align: right;
  padding: 8px;
}

.m-creat-box {
  min-height: 165px;
}

.m-download {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  height: 32px;
  line-height: 32px;
}

.empty-block {
  background: #f3f3f3;
  height: 210px;
  border-radius: 5px;
  line-height: 210px;
  text-align: center;
  font-size: 16px;
}

.c-idea {
  height: inherit;

  .m-bread {
    line-height: 20px;
    margin-bottom: 12px;
  }

  .module-content {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;

    height: calc(100% - 96px);
  }

  .c-idea-submit {
    padding: 15px;
    min-width: 1130px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 #eff1fa;

    .c-btns-submit {
      text-align: right;

      button {
        margin-left: 8px !important;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
}

.c-idea-bar {
  position: relative;
  flex: auto;
  display: flex;
  justify-content: space-between;
  padding: 15px 12px 15px 48px;
  background-color: #ffffff;
  white-space: nowrap;

  .c-bar-content {
    overflow-x: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;

    height: inherit;
    display: inline-block;
    flex: auto;
    padding: 5px 0;

    .m-creative-btn {
      border-radius: 4px;
      border: solid 1px #efefef;
      position: relative;
      display: inline-block;
      line-height: 32px;
      padding: 0 12px;
      margin-right: 12px;

      .m-creat-btn {
        color: #2b85e4;
      }

      .m-remove {
        position: absolute;
        cursor: pointer;
        color: #fff;
        width: 11px;
        height: 11px;
        line-height: 11px;
        font-size: 60%;
        border-radius: 9px;
        background-color: #ff635c;
        text-align: center;
        display: block;
        z-index: 11;
        top: -6px;
        right: -3px;
        transition: display 0.2s ease-in-out;
      }
    }

    .m-current {
      color: #ffffff;
      border-color: #2b85e4;
      background-color: #2b85e4;
    }
  }

  .c-add-btn {
    padding-top: 6px;

    text-align right {
      button {
        margin-left: 10px !important;

        &:first-child {
          margin-left: 0 !important;
        }
      }
    }
  }
}

::v-deep.col-flex {
  min-height: 32px;
  display: flex;
  align-items: center;
}

.ivu-affix .c-idea-bar {
  border-bottom: 1px solid #e8eaec;
}

::v-deep .ivu-btn {
  margin-right: 8px;
}
</style>
